import React from "react";
import { Field, ErrorMessage } from "formik";
import { CURRENCY } from "../../components/Constants";
import ReactSelect from "react-select";

interface ProductRowProps {
  item: any;
  index: number;
  productList: Array<{ id: string; name: string; description: string }>;
  unitList: any;
  values: any;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  remove: (index: number) => void;
  handleChange: any;
  setAddUnitModalStatus: (show: boolean) => void;
  setAddProductModalStatus: (show: boolean) => void;
  productWiseUsedQty?: {
    [productId: string]: { usedQty: number; remainingQty: number };
  };
  errors: any;
  setFieldError?: any;
  permissions: any;
}

const ProductRow: React.FC<ProductRowProps> = ({
  item,
  index,
  productList,
  unitList,
  values,
  setFieldValue,
  remove,
  handleChange,
  setAddUnitModalStatus,
  setAddProductModalStatus,
  productWiseUsedQty,
  errors,
  setFieldError,
  permissions,
}) => {
  const handleProductCalculation = (index: any) => {
    let subTotal = 0;
    let sgst = 0;
    let cgst = 0;
    let totalGst = 0;
    let finalTotal = 0;

    if (
      values.purchase_items[index].price &&
      values.purchase_items[index].quantity
    ) {
      subTotal =
        Number(values.purchase_items[index].price) *
        Number(values.purchase_items[index].quantity);
    }

    if (values.purchase_items[index]?.gst_percentage && subTotal) {
      totalGst = Number(
        (subTotal * Number(values.purchase_items[index]?.gst_percentage)) / 100
      );
      sgst = totalGst / 2;
      cgst = totalGst / 2;
    }

    finalTotal = Number(subTotal) + Number(totalGst);

    setFieldValue(`purchase_items.${index}.sub_total`, subTotal.toFixed(2));
    setFieldValue(`purchase_items.${index}.cgst`, cgst.toFixed(2));
    setFieldValue(`purchase_items.${index}.sgst`, sgst.toFixed(2));
    setFieldValue(`purchase_items.${index}.gst_amount`, totalGst.toFixed(2));
    setFieldValue(`purchase_items.${index}.total`, finalTotal.toFixed(2));

    let subTotalAll = 0;
    let sgstAll = 0;
    let cgstAll = 0;
    let totalGstAll = 0;
    let finalTotalAll = 0;

    if (values?.purchase_items) {
      values?.purchase_items.map((row: any) => {
        if (row.price && row.quantity) {
          subTotalAll += Number(row.price) * Number(row.quantity);
        }
        if (row?.gst_percentage) {
          totalGstAll += Number(
            (Number(row.price) *
              Number(row.quantity) *
              Number(row?.gst_percentage)) /
              100
          );
          sgstAll = totalGstAll / 2;
          cgstAll = totalGstAll / 2;
        }
        return "";
      });
    }

    finalTotalAll =
      Number(subTotalAll) + Number(totalGstAll) + Number(values?.round_of);

    setFieldValue(`sub_total`, subTotalAll.toFixed(2));
    setFieldValue(`cgst`, cgstAll.toFixed(2));
    setFieldValue(`sgst`, sgstAll.toFixed(2));
    setFieldValue(`gst_amount`, totalGstAll.toFixed(2));
    setFieldValue(`total`, finalTotalAll.toFixed(2));
  };

  const handleProductRemoveCalculation = (newPurchaseItems: any) => {
    let subTotalAll = 0;
    let sgstAll = 0;
    let cgstAll = 0;
    let totalGstAll = 0;
    let finalTotalAll = 0;

    if (newPurchaseItems) {
      newPurchaseItems.map((row: any) => {
        if (row.price && row.quantity) {
          subTotalAll += Number(row.price) * Number(row.quantity);
        }
        if (row?.gst_percentage) {
          totalGstAll += Number(
            (Number(row.price) *
              Number(row.quantity) *
              Number(row?.gst_percentage)) /
              100
          );
          sgstAll = totalGstAll / 2;
          cgstAll = totalGstAll / 2;
        }
        return "";
      });
    }

    finalTotalAll =
      Number(subTotalAll) + Number(totalGstAll) + Number(values?.round_of);

    setFieldValue(`sub_total`, subTotalAll);
    setFieldValue(`cgst`, cgstAll);
    setFieldValue(`sgst`, sgstAll);
    setFieldValue(`gst_amount`, totalGstAll);
    setFieldValue(`total`, finalTotalAll);
  };

  return (
    <div
      className="row m-0 mb-3 gy-1"
      style={{
        border: "1px solid #d1d0d4",
        borderRadius: "0.375rem",
        padding: "10px 5px 20px 5px",
      }}
    >
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <div className="d-flex justify-content-between">
          <div>
            <label
              htmlFor="product_id"
              className="form-label"
              style={{ fontSize: "0.9375rem" }}
            >
              Product: <span className="text-danger">*</span>
            </label>
          </div>
          {permissions.includes("create-product") && (
            <div>
              <button
                title="Add Product"
                className="btn btn-sm btn-primary waves-effect waves-light p-0"
                type="button"
                onClick={() => setAddProductModalStatus(true)}
              >
                <span>
                  <i className="ti ti-plus my-card-icon-button"></i>
                </span>
              </button>
            </div>
          )}
        </div>
        <Field name={`purchase_items.${index}.product_id`}>
          {({ field, form }: any) => {
            const selectedOption = productList.find(
              (option: any) => option.id === field.value
            );
            const formatOptionLabel = (option: any, { context }: any) => {
              if (context === "value") {
                return option.name;
              } else {
                return (
                  <div>
                    <label className="form-label">{option.name}</label>
                    <br />
                    <span className="form-label">{option.description}</span>
                  </div>
                );
              }
            };
            return (
              <>
                <ReactSelect
                  {...field}
                  classNamePrefix="react-select"
                  placeholder="Select Product"
                  options={productList.map((option: any) => ({
                    ...option,
                    isDisabled: values.purchase_items.some(
                      (p: any) => p.product_id === option.id
                    ),
                  }))}
                  getOptionLabel={(option: any) => option.name}
                  formatOptionLabel={formatOptionLabel}
                  getOptionValue={(option: any) => option.id}
                  onChange={(selectedOption: any) => {
                    if (
                      productWiseUsedQty &&
                      productWiseUsedQty.hasOwnProperty(
                        values.purchase_items[index].product_id
                      ) &&
                      productWiseUsedQty[
                        values.purchase_items[index].product_id
                      ].usedQty > 0
                    ) {
                      setFieldError(
                        `purchase_items[${index}].product_id`,
                        `You can not remove this product,it is used in Sales Contract's suppliers products`
                      );
                      return;
                    }

                    setFieldValue(
                      `purchase_items.${index}.product_id`,
                      selectedOption ? selectedOption.id : ""
                    );
                  }}
                  value={selectedOption || ""}
                  isClearable
                  isSearchable
                />
                {form.errors.purchase_items &&
                  form.errors.purchase_items[index] &&
                  form.errors.purchase_items[index].product_id && (
                    <div className="text-danger">
                      {form.errors.purchase_items[index].product_id}
                    </div>
                  )}
              </>
            );
          }}
        </Field>
      </div>

      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label className="form-label" style={{ fontSize: "0.9375rem" }}>
          Price ({CURRENCY.INR.SYMBOL}): <span className="text-danger">*</span>
        </label>
        <Field
          id={`purchase_items.${index}.price`}
          name={`purchase_items.${index}.price`}
          type="number"
          className="form-control"
          placeholder="Enter Price"
          value={item?.price || ""}
          onChange={(e: any) => {
            values.purchase_items[index].price =
              parseFloat(e.target.value) || "";
            handleProductCalculation(index);
          }}
        />
        <ErrorMessage
          name={`purchase_items.${index}.price`}
          component="div"
          className="text-danger"
        />
      </div>
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label className="form-label" style={{ fontSize: "0.9375rem" }}>
          Quantity (MTS): <span className="text-danger">*</span>
        </label>
        <Field
          id={`purchase_items.${index}.quantity`}
          name={`purchase_items.${index}.quantity`}
          type="number"
          className="form-control"
          placeholder="Enter Quantity"
          value={item?.quantity || ""}
          onChange={(e: any) => {
            const currentIndex = values.purchase_items[index];
            if (
              productWiseUsedQty &&
              productWiseUsedQty.hasOwnProperty(currentIndex.product_id) &&
              e.target.value <
                productWiseUsedQty[currentIndex.product_id].usedQty
            ) {
              setFieldError(
                `purchase_items[${index}].quantity`,
                `You can not reduce this product quantity less then ${
                  productWiseUsedQty[currentIndex.product_id].usedQty
                },it used in sales contract's supplier products`
              );
              return;
            }
            currentIndex.quantity = parseFloat(e.target.value) || "";
            handleProductCalculation(index);
          }}
        />
        {errors.purchase_items &&
          errors.purchase_items[index] &&
          errors.purchase_items[index].quantity && (
            <div className="text-danger">
              {errors.purchase_items[index].quantity}
            </div>
          )}
      </div>

      {/* Quantity unit is always in MTS */}
      {/* <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <div className="d-flex justify-content-between">
          <div>
            <label className="form-label" style={{ fontSize: "0.9375rem" }}>
              Unit: <span className="text-danger">*</span>
            </label>
          </div>
          <div>
            <button
              title="Add Unit"
              className="btn btn-sm btn-primary waves-effect waves-light p-0"
              type="button"
              onClick={() => setAddUnitModalStatus(true)}
            >
              <span>
                <i className="ti ti-plus my-card-icon-button"></i>
              </span>
            </button>
          </div>
        </div>
        <Field
          as="select"
          name={`purchase_items.${index}.unit_id`}
          className="form-select"
          values={values.unit_id}
        >
          <option defaultChecked value={""}>
            Select Quantity Unit
          </option>
          {unitList.map((unit: any) => (
            <option key={unit.id} value={unit.id}>
              {unit.name}
            </option>
          ))}
        </Field>
        <ErrorMessage
          name={`purchase_items.${index}.unit_id`}
          component="div"
          className="text-danger"
        />
      </div> */}

      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label className="form-label" style={{ fontSize: "0.9375rem" }}>
          No of Bags:
        </label>
        <Field
          id={`purchase_items.${index}.no_of_bags`}
          name={`purchase_items.${index}.no_of_bags`}
          type="number"
          className="form-control"
          placeholder="Enter No of Bags"
          value={item?.no_of_bags || null}
          onChange={handleChange}
        />
        <ErrorMessage
          name={`purchase_items.${index}.no_of_bags`}
          className="text-danger"
          component="div"
        />
      </div>
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label
          htmlFor={`purchase_items.${index}.sub_total`}
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          SubTotal ({CURRENCY.INR.SYMBOL}):
        </label>
        <Field
          id={`purchase_items.${index}.sub_total`}
          name={`purchase_items.${index}.sub_total`}
          value={parseFloat(values?.purchase_items[index]?.sub_total).toFixed(
            2
          )}
          type="number"
          className="form-control"
          disabled
        />
        <ErrorMessage
          name={`purchase_items.${index}.sub_total`}
          component="div"
          className="text-danger"
        />
      </div>
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label
          htmlFor={`purchase_items.${index}.gst_percentage`}
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          GST Percentage: <span className="text-danger">*</span>
        </label>
        <Field
          as="select"
          id={`purchase_items.${index}.gst_percentage`}
          name={`purchase_items.${index}.gst_percentage`}
          className="form-select"
          onChange={(e: any) => {
            handleChange(e);
            values.purchase_items[index].gst_percentage = parseFloat(
              e.target.value
            );
            handleProductCalculation(index);
          }}
        >
          <option value="">Select Percentage</option>
          <option value="0">0%</option>
          <option value="5">5%</option>
          <option value="18">18%</option>
          <option value="28">28%</option>
        </Field>
        <ErrorMessage
          name={`purchase_items.${index}.gst_percentage`}
          component="div"
          className="text-danger"
        />
      </div>
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label
          htmlFor={`purchase_items.${index}.cgst`}
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          CGST ({CURRENCY.INR.SYMBOL}):
        </label>
        <Field
          id={`purchase_items.${index}.cgst`}
          name={`purchase_items.${index}.cgst`}
          type="number"
          className="form-control"
          value={parseFloat(values?.purchase_items[index]?.cgst).toFixed(2)}
          disabled
        />
        <ErrorMessage
          name={`purchase_items.${index}.cgst`}
          component="div"
          className="text-danger"
        />
      </div>
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label
          htmlFor={`purchase_items.${index}.sgst`}
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          SGST ({CURRENCY.INR.SYMBOL}):
        </label>
        <Field
          id={`purchase_items.${index}.sgst`}
          name={`purchase_items.${index}.sgst`}
          type="number"
          className="form-control"
          value={parseFloat(values?.purchase_items[index]?.sgst).toFixed(2)}
          disabled
        />
        <ErrorMessage
          name={`purchase_items.${index}.sgst`}
          component="div"
          className="text-danger"
        />
      </div>
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label
          htmlFor={`purchase_items.${index}.gst_amount`}
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          GST Amount ({CURRENCY.INR.SYMBOL}):
        </label>
        <Field
          id={`purchase_items.${index}.gst_amount`}
          name={`purchase_items.${index}.gst_amount`}
          type="number"
          className="form-control"
          value={parseFloat(values?.purchase_items[index]?.gst_amount).toFixed(
            2
          )}
          disabled
        />
        <ErrorMessage
          name={`purchase_items.${index}.gst_amount`}
          component="div"
          className="text-danger"
        />
      </div>
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label
          htmlFor={`purchase_items.${index}.total`}
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          Total ({CURRENCY.INR.SYMBOL}):
        </label>
        <Field
          id={`purchase_items.${index}.total`}
          name={`purchase_items.${index}.total`}
          type="number"
          className="form-control"
          value={parseFloat(values?.purchase_items[index]?.total).toFixed(2)}
          disabled
        />
      </div>
      <div className="col-12 col-sm-6 col-lg-3 d-flex align-items-end">
        <button
          type="button"
          className="btn btn-danger mt-3"
          onClick={() => {
            if (
              productWiseUsedQty &&
              productWiseUsedQty.hasOwnProperty(
                values.purchase_items[index].product_id
              ) &&
              productWiseUsedQty[values.purchase_items[index].product_id]
                .usedQty > 0
            ) {
              setFieldError(
                `purchase_items[${index}].product_id`,
                `You can not remove this product,it is used in Sales Contract's suppliers products`
              );
              return;
            }

            remove(index);
            const newPurchaseItems = values.purchase_items.filter(
              (x: any, indexKey: any) => indexKey !== index
            );
            handleProductRemoveCalculation(newPurchaseItems);
          }}
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default ProductRow;
